import { Injectable, signal } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IFiltersProperties } from '@shared/model/filter-properties.model';

export interface ISumaryData {
  total: number;
  load: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FilterPropertiesDataService {
  public filtersData = new Subject<any>();
  public dataSumary = new Subject<ISumaryData>();

  public filtersApplied: IFiltersProperties;
  private _filters: any | null = null;

  // Creacion de Signals
  public signalFilters = signal<IFiltersProperties>({ pagina: '1' });

  constructor(
    private router: Router,
    private translateService: TranslateService
  ) {}
  private _lastRouteHash: string | null = null;
  setDataSumary(sumaryData: ISumaryData): Observable<any> {
    this.dataSumary.next(sumaryData);
    return of(sumaryData);
  }

  putFiltersProperties(filters: any): Observable<any> {
    this._filters = filters || null;
    this.filtersData.next(filters);
    return of(filters);
  }

  get filters(): any | null {
    return this._filters;
  }

  buildQueryPublications(
    applyFilters: IFiltersProperties,
    hasBuilding: boolean = false,
    reset = false,
    currentRouteSegment: string = 'invertir'
  ) {
    this.filtersData.next(applyFilters);

    if (reset) {
      this.signalFilters.set(applyFilters);
    } else {
      this.setFiltersProperties(applyFilters);
    }
    this.changeUrl(this.signalFilters(), currentRouteSegment);
  }

  reset() {
    this.signalFilters.set(null);
  }

  setFiltersProperties(filters: IFiltersProperties) {
    this.signalFilters.update((currentValue: IFiltersProperties) => {
      return { ...currentValue, ...filters };
    });
  }

  public changeUrl(filters: any, currentRouteSegment?: string) {
    const params: any = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        if (key != 'ubicacion') {
          Object.defineProperty(params, key, {
            enumerable: true,
            writable: true,
            configurable: true,
            value: filters[key],
          });
        }
      }
    });
    const parametros =
      (filters.prov ? '/' + filters.prov : '') +
      (filters.loc ? '/' + filters.loc : '');

    const newRoute =
      this.translateService.getCurrentLang() +
      '/' +
      currentRouteSegment;// +
    //  parametros;

    const routeHash = newRoute + '|' + JSON.stringify(params || {});
    if (this._lastRouteHash === routeHash) {
      return;
    }
    this._lastRouteHash = routeHash;

    this.router.navigate([newRoute], {
      queryParams: params,
      replaceUrl: true,
    });
  }
}
